





























import Vue, { PropType } from 'vue'
import CreateDialog from '@/components/CreateDialog.vue'
import { Provider } from '@/utils/interfaces/topup.interface'
import { number } from '@/utils/validators'
import {
  updateProviderCredit,
  updateSharedProviderCredit,
} from '@/api/Topup/topup.api'
import { VueForm } from '@/utils/interfaces'

export default Vue.extend({
  components: {
    appCreateDialog: CreateDialog,
  },
  props: {
    provider: Object as PropType<Provider>,
    agency: String,
    shared: Boolean,
    multiplication: Number,
  },
  data: function() {
    return {
      rules: {
        greaterThan: (value: number) =>
          value >= 0 ||
          this.$t('validation.must-be-greater-than-equal', {
            value: 0,
          }),
        number: (value: string) =>
          number((value || '').toString()) ||
          this.$t('validation.must-be-a-number'),
        required: (v: number) => !!v || this.$t('validation.field-required'),
      },
      loading: false,
      crud: {
        credit: 0,
        description: '',
      },
    }
  },
  methods: {
    async onSuccess() {
      if (!(this.$refs.form as VueForm).validate()) return
      this.loading = true
      try {
        const credit = this.crud.credit * this.multiplication
        if (this.shared) {
          await updateSharedProviderCredit({
            ...this.crud,
            provider: this.provider.uuid,
            credit: credit,
          })
        } else {
          await updateProviderCredit({
            ...this.crud,
            provider: this.provider.uuid,
            agency: this.agency,
            credit: credit,
          })
        }
        this.$emit('success', credit)
        this.$emit('input', false)
        ;(this.$refs.form as VueForm).reset()
      } finally {
        this.loading = false
      }
    },
  },
})
